var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMrFamilyRecPodLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 36,
    viewBox: "0 0 178 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 36,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trial top PC 1475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1601.83,
    transform: "translate(-868.112 -912)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -329.112,
    y: -788,
    width: 821,
    height: 958.605,
    rx: 20,
    fill: "#ECF5FD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "usecase"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-description"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2609392"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -213.612,
    y: -12,
    width: 590,
    height: 142.605,
    rx: 10,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "functions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "service_MR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MiiTel/recpod"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6758 13.8499C15.6758 13.0898 15.0596 12.4736 14.2996 12.4736C13.5395 12.4736 12.9233 13.0898 12.9233 13.8499V18.0392C12.9233 18.7993 13.5395 19.4155 14.2996 19.4155C15.0596 19.4155 15.6758 18.7993 15.6758 18.0392V13.8499Z",
    fill: "#3BE0CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2997 24.2144C15.2352 24.2144 15.9936 23.456 15.9936 22.5204C15.9936 21.5848 15.2352 20.8264 14.2997 20.8264C13.3641 20.8264 12.6057 21.5848 12.6057 22.5204C12.6057 23.456 13.3641 24.2144 14.2997 24.2144Z",
    fill: "#3BE0CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.1787 8.79569C21.1787 8.0356 20.5626 7.41943 19.8025 7.41943C19.0424 7.41943 18.4263 8.0356 18.4263 8.79569V26.8092C18.4263 27.5693 19.0424 28.1854 19.8025 28.1854C20.5626 28.1854 21.1787 27.5693 21.1787 26.8092V8.79569Z",
    fill: "#209CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.6836 16.5469C26.6836 15.7868 26.0674 15.1707 25.3074 15.1707C24.5473 15.1707 23.9312 15.7868 23.9312 16.5469V23.4739C23.9312 24.234 24.5473 24.8501 25.3074 24.8501C26.0674 24.8501 26.6836 24.234 26.6836 23.4739V16.5469Z",
    fill: "#3BE0CC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.1873 14.4983C32.1873 13.7382 31.5711 13.1221 30.811 13.1221C30.051 13.1221 29.4348 13.7382 29.4348 14.4983V21.5683C29.4348 22.3284 30.051 22.9445 30.811 22.9445C31.5711 22.9445 32.1873 22.3284 32.1873 21.5683V14.4983Z",
    fill: "#209CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.8112 11.867C31.7467 11.867 32.5051 11.1086 32.5051 10.173C32.5051 9.23744 31.7467 8.479 30.8112 8.479C29.8756 8.479 29.1172 9.23744 29.1172 10.173C29.1172 11.1086 29.8756 11.867 30.8112 11.867Z",
    fill: "#209CFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.1719 17.229C10.1719 16.469 9.55573 15.8528 8.79566 15.8528C8.03559 15.8528 7.41943 16.469 7.41943 17.229V21.1602C7.41943 21.9203 8.03559 22.5365 8.79566 22.5365C9.55573 22.5365 10.1719 21.9203 10.1719 21.1602V17.229Z",
    fill: "#209CFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MiiTel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.5637 11.5902C55.5637 10.9319 55.0484 10.4155 54.389 10.4155H54.1011C53.6294 10.4155 53.2898 10.6112 53.0297 11.0302L48.1444 18.6681L43.2829 11.054C43.0109 10.6241 42.6534 10.4146 42.1877 10.4146H41.8998C41.2414 10.4146 40.7251 10.9299 40.7251 11.5892V24.5882C40.7251 25.2326 41.2106 25.7182 41.8551 25.7182C42.4995 25.7182 43.0069 25.2217 43.0069 24.5882V14.6545L47.1356 20.8467C47.4106 21.2707 47.7164 21.4673 48.0997 21.4673C48.5028 21.4673 48.8067 21.2767 49.0847 20.8487L53.2362 14.6089V24.5664C53.2362 25.1909 53.7635 25.7182 54.388 25.7182C55.0464 25.7182 55.5627 25.2118 55.5627 24.5664V11.5902H55.5637Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.74 19.5818C60.74 18.9354 60.2336 18.4299 59.5882 18.4299C58.9428 18.4299 58.4583 18.9363 58.4583 19.5818V24.5893C58.4583 25.2228 58.9547 25.7193 59.5882 25.7193C60.2217 25.7193 60.74 25.2228 60.74 24.5893V19.5818Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M75.0017 10.5051H64.7048C64.118 10.5051 63.6414 10.9827 63.6414 11.5686C63.6414 12.1545 64.119 12.6321 64.7048 12.6321H68.6677V24.5666C68.6677 25.2021 69.1949 25.7184 69.8423 25.7184C70.4897 25.7184 71.017 25.2011 71.017 24.5666V12.6321H75.0017C75.5756 12.6321 76.0433 12.1554 76.0433 11.5686C76.0433 10.9818 75.5756 10.5051 75.0017 10.5051Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M88.7628 10.8595C88.7628 10.2369 88.2454 9.72949 87.6109 9.72949C86.9764 9.72949 86.481 10.226 86.481 10.8595V24.5883C86.481 25.2218 86.9774 25.7183 87.6109 25.7183C88.2444 25.7183 88.7628 25.2218 88.7628 24.5883V10.8595Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M59.599 17.2056C60.3141 17.2056 60.8938 16.6259 60.8938 15.9108C60.8938 15.1957 60.3141 14.616 59.599 14.616C58.8839 14.616 58.3042 15.1957 58.3042 15.9108C58.3042 16.6259 58.8839 17.2056 59.599 17.2056Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M65.3541 19.5818C65.3541 18.9354 64.8477 18.4299 64.2022 18.4299C63.5568 18.4299 63.0723 18.9363 63.0723 19.5818V24.5893C63.0723 25.2228 63.5687 25.7193 64.2022 25.7193C64.8357 25.7193 65.3541 25.2228 65.3541 24.5893V19.5818Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M64.2133 17.2056C64.9284 17.2056 65.5081 16.6259 65.5081 15.9108C65.5081 15.1957 64.9284 14.616 64.2133 14.616C63.4982 14.616 62.9185 15.1957 62.9185 15.9108C62.9185 16.6259 63.4982 17.2056 64.2133 17.2056Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M83.111 15.8651C82.4238 15.0459 81.1688 14.0708 79.0895 14.0708C75.9459 14.0708 73.5747 16.6029 73.5747 19.9621V20.0068C73.5747 23.4077 76.0154 25.8752 79.3775 25.8752C80.991 25.8752 82.3226 25.3857 83.4476 24.3798C83.5588 24.2676 83.7395 24.0343 83.7395 23.7046C83.7395 23.1992 83.3681 22.8179 82.8756 22.8179C82.6175 22.8179 82.4834 22.8854 82.3106 23.0194C81.4458 23.7314 80.4985 24.0799 79.4212 24.0799C77.5167 24.0799 76.1514 22.8784 75.8595 20.9441L75.8247 20.7158H83.385C83.9917 20.7158 84.4485 20.2491 84.4485 19.6304C84.4485 18.2512 83.9609 16.8789 83.111 15.8661V15.8651ZM79.0667 15.8651C80.8004 15.8651 82.0078 17.0964 82.2263 19.0803H75.8416C76.1167 17.1262 77.3797 15.8651 79.0667 15.8651Z",
    fill: "#494949"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RecPod"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M99.2565 24.4629C99.2565 25.0944 98.762 25.5889 98.1305 25.5889C97.499 25.5889 96.9827 25.0944 96.9827 24.4629V11.6198C96.9827 10.9654 97.4762 10.4719 98.1305 10.4719H103.604C105.416 10.4719 106.893 10.9803 107.876 11.9415C108.668 12.7548 109.087 13.847 109.087 15.1012V15.1448C109.087 17.3036 107.903 18.8566 105.753 19.5199L105.46 19.6102L108.585 23.5513C108.839 23.8691 108.977 24.1064 108.977 24.449C108.977 25.0904 108.415 25.4876 107.895 25.4876C107.417 25.4876 107.063 25.297 106.746 24.867L103.025 20.1166L102.962 20.0362H99.2565V24.4629ZM106.69 15.2978V15.2541C106.69 13.5571 105.485 12.584 103.385 12.584H99.336V17.9897H103.407C105.401 17.9897 106.69 16.9332 106.69 15.2978Z",
    fill: "#209CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M131.161 23.4401C131.161 22.9158 130.744 22.4899 130.232 22.4899C129.943 22.4899 129.71 22.6686 129.647 22.7242C128.779 23.461 127.915 23.8036 126.927 23.8036C124.836 23.8036 123.258 22.1225 123.258 19.8942V19.8505C123.258 17.67 124.822 15.9631 126.818 15.9631C128.037 15.9631 128.852 16.5161 129.426 16.9977C129.473 17.0325 129.731 17.2112 130.08 17.2112C130.649 17.2112 131.095 16.7743 131.095 16.2163C131.095 15.7784 130.808 15.5053 130.751 15.4547C129.655 14.5044 128.411 14.0615 126.839 14.0615C123.581 14.0615 121.028 16.6234 121.028 19.8942V19.9379C121.028 23.172 123.561 25.7051 126.795 25.7051C128.458 25.7051 129.709 25.2166 130.853 24.1213L130.864 24.1114C131.062 23.9505 131.161 23.7251 131.161 23.4411V23.4401Z",
    fill: "#209CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M143.597 11.8661C142.602 10.9823 141.178 10.5156 139.478 10.5156H134.793C134.139 10.5156 133.645 11.0091 133.645 11.6635V24.4639C133.645 25.0954 134.15 25.5899 134.793 25.5899C135.437 25.5899 135.919 25.0954 135.919 24.4639V20.496H139.172C142.768 20.496 145.092 18.5249 145.092 15.4735V15.4298C145.092 13.9682 144.575 12.7369 143.598 11.8671L143.597 11.8661ZM142.774 15.5381C142.774 17.3006 141.361 18.4842 139.258 18.4842H135.918V12.5472H139.258C141.46 12.5472 142.774 13.6484 142.774 15.4934V15.5371V15.5381Z",
    fill: "#209CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M155.164 15.7595C156.251 16.8369 156.848 18.2896 156.848 19.8496V19.8933C156.848 23.1522 154.219 25.7041 150.863 25.7041C147.507 25.7041 144.943 23.171 144.943 19.9369V19.8933C144.943 16.6224 147.562 14.0605 150.907 14.0605C152.549 14.0605 154.061 14.6643 155.164 15.7595ZM150.863 16.0415C148.771 16.0415 147.251 17.6432 147.251 19.8496V19.8933C147.251 22.041 148.857 23.7231 150.907 23.7231C152.956 23.7231 154.54 22.1304 154.54 19.9369V19.8933C154.54 17.6968 152.959 16.0415 150.863 16.0415Z",
    fill: "#209CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M118.967 15.7594C118.285 14.9471 117.039 13.979 114.975 13.979C111.854 13.979 109.501 16.4942 109.501 19.8306V19.8753C109.501 23.2524 111.925 25.704 115.263 25.704C116.866 25.704 118.189 25.2184 119.307 24.2185C119.41 24.1143 119.586 23.8888 119.586 23.5731C119.586 23.0905 119.232 22.7261 118.762 22.7261C118.514 22.7261 118.391 22.7886 118.222 22.9197C117.349 23.6386 116.396 23.9881 115.307 23.9881C113.381 23.9881 112.002 22.7737 111.706 20.8186L111.664 20.5445H119.271C119.855 20.5445 120.295 20.0947 120.295 19.4989C120.295 18.1286 119.811 16.7663 118.967 15.7604V15.7594ZM111.682 18.9885L111.688 18.9429C111.966 16.9688 113.247 15.6939 114.953 15.6939C116.659 15.6939 117.932 16.939 118.152 18.9439L118.157 18.9875H111.682V18.9885Z",
    fill: "#209CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M166.608 24.4926V23.6496L166.537 23.7449C165.951 24.5254 165.036 25.4478 163.153 25.6564C162.897 25.6921 162.643 25.71 162.393 25.702H162.35L162.344 25.701H162.32C161.067 25.6564 159.842 25.1152 158.958 24.2146C157.916 23.1521 157.366 21.6795 157.366 19.9547V19.911C157.366 18.1952 157.9 16.7325 158.91 15.683C159.809 14.7476 161.021 14.2084 162.319 14.1657H162.335H162.342H162.378C162.653 14.1558 162.932 14.1746 163.209 14.2154C164.547 14.3643 165.636 14.8608 166.54 15.7326L166.607 15.7972V10.9961C166.607 10.3815 167.089 9.8999 167.703 9.8999C168.318 9.8999 168.821 10.3815 168.821 10.9961V24.4936C168.821 25.1082 168.34 25.5898 167.725 25.5898C167.11 25.5898 166.607 25.1082 166.607 24.4936L166.608 24.4926ZM163.116 16.107C161.126 16.107 159.681 17.7066 159.681 19.911V19.9547C159.681 22.1234 161.158 23.7588 163.116 23.7588C165.074 23.7588 166.572 22.0876 166.572 19.9547V19.911C166.572 17.7424 165.087 16.107 163.116 16.107Z",
    fill: "#209CFF"
  }))))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrFamilyRecPodLogo);
export default __webpack_public_path__ + "static/media/MrFamily_RecPod_Logo.9afcb2e36d4073ff75285f9669a499f9.svg";
export { ForwardRef as ReactComponent };